<template>
  <b-sidebar id="add-new-location-sidebar" :visible="isAddNewLocationSidebarActive" bg-variant="white"
    sidebar-class="sidebar-lg" shadow backdrop no-header right @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-location-sidebar-active', val)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New Location
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />

      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="resetForm">

          <!-- Locationname -->
          <validation-provider #default="validationContext" name="Location Name" rules="required">
            <b-form-group label="Location Name" label-for="locationname">
              <b-form-input id="locationname" v-model="locationData.locationname"
                :state="getValidationState(validationContext)" trim />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Country -->
          <validation-provider #default="validationContext" name="Country" rules="required">
            <b-form-group label="Country" label-for="country" :state="getValidationState(validationContext)">
              <v-select v-model="locationData.country" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="countries" :clearable="false" input-id="country" />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-2" type="submit">
              Add
            </b-button>
            <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="button" variant="outline-secondary"
              @click="hide">
              Cancel
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, getCurrentInstance } from '@vue/composition-api'
import { required, alphaNum } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewLocationSidebarActive',
    event: 'update:is-add-new-location-sidebar-active',
  },
  props: {
    isAddNewLocationSidebarActive: {
      type: Boolean,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      countries,
    }
  },
  setup(props, { emit }) {
    const blankLocationData = {
      locationname: '',
      country: '',
    }

    const locationData = ref(JSON.parse(JSON.stringify(blankLocationData)))
    const resetlocationData = () => {
      locationData.value = JSON.parse(JSON.stringify(blankLocationData))
    }

    const { proxy } = getCurrentInstance()


    const onSubmit = () => {
      const location = `${locationData.value.locationname}, ${locationData.value.country}`
      // console.log({ name: location })
      store.dispatch('app-location/addLocation', { "name": location })
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-location-sidebar-active', false)
          proxy.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Location Added Successfully!',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        }).catch((err) => {
          const errorMessage = (err.response && err.response.data && err.response.data.error) || 'Something went wrong.'
          proxy.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              text: errorMessage,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetlocationData)

    return {
      locationData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-location-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
